
import { Component } from '@angular/core';
import { AppData } from '../../../app-data';
import { Brand } from '../../../model/api/assets/brand';
import { Param } from '../../../model/common/param';
import { GenericTableList } from '../../generic/generic.table.list';

@Component({
    selector: 'brand-list',
    templateUrl: '../../generic/generic.table.list.html'
})
export class BrandList extends GenericTableList<Brand, number> {
    private listName: string = 'BRANDS';

    constructor() {
        super('name', 'asc', '');
        this.columns = AppData.ColumnDefinitions[this.listName];
    }

    public refresh(filters: Array<Param>) {
        this.columns = AppData.ColumnDefinitions[this.listName];
        super.refresh(filters);
    }
}